 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		16: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		16: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"eb6566f42565116308653f3d7ce716ddf3ab8d17","1":"2190e78c9daf4fab12dcee896403284741fd04dd","2":"styles","3":"09ba394c0665ec418beca5b9b20034fcbde74fdd","4":"8d1525f042279c504ed168ad26bd3afb2b2ab8c9","5":"a31980b1aa85f30412c1f61ee95f537dc2fe751c","6":"c12e60e7812e7433aa4d5228386c97d68b97f84c","7":"64b3804f7f48199f92d2b55a5eeac25417a4d075","8":"ec5c89a41aee28bbbfacb409a2e54bb31dec6f0f","9":"f0a8d1f93450005d571c1d9025195a10a7bb448e","10":"35df7e74774a94bfcd80eecbe4d85d2b3ae421d9","11":"3a153b92dded9af167fb9e42e48b843230cb12d3","12":"9f53efbd860637e77fc522713c17b5b048c0ab77","13":"a89bf5dab39d3bc6a5630fe2668c9dea90dc6cb6","14":"b58c2f089a40321ecd27b95a2d57fd8521f8b7a6","15":"e7ed3f1f536a60b0171a5d0b396cd70adcd45db2","17":"4a3ea9cd","19":"component---src-pages-404-js","20":"component---src-pages-404-old-js","21":"component---src-pages-custom-order-paid-js","22":"component---src-pages-custom-orders-js","23":"component---src-pages-order-paid-js","24":"component---src-pages-order-pay-failed-js","25":"component---src-pages-test-js","26":"component---src-pages-videos-js","27":"component---src-templates-about-us-js","28":"component---src-templates-admin-js","29":"component---src-templates-audios-js","30":"component---src-templates-author-js","31":"component---src-templates-authors-js","32":"component---src-templates-book-js","33":"component---src-templates-books-fairs-js","34":"component---src-templates-books-js","35":"component---src-templates-cart-items-new-js","36":"component---src-templates-cart-items-old-js","37":"component---src-templates-categories-js","38":"component---src-templates-category-js","39":"component---src-templates-checkout-js","40":"component---src-templates-checkout-new-js","41":"component---src-templates-contact-us-js","42":"component---src-templates-cookies-policy-js","43":"component---src-templates-feedback-js","44":"component---src-templates-gallery-page-js","45":"component---src-templates-get-brochure-js","46":"component---src-templates-index-js","47":"component---src-templates-login-redirect-js","48":"component---src-templates-mobile-about-us-js","49":"component---src-templates-my-profile-js","50":"component---src-templates-order-book-js","51":"component---src-templates-policy-js","52":"component---src-templates-publisher-js","53":"component---src-templates-publishers-js","54":"component---src-templates-signup-js","55":"component---src-templates-your-thoughts-js"}[chunkId]||chunkId) + "-" + {"0":"8a2758b85a130ea057d8","1":"3557f8f94865f13bda04","2":"7d4153d260c0197f0043","3":"52829ab37ec7b9eed481","4":"5710cc17e96418b3af36","5":"0207ca796cc5c28a8fd7","6":"3ff6ba05ef369246819f","7":"3e64d39ab62d994cee75","8":"d2dcf9d9361d3499994d","9":"99ce2fd42f092915df44","10":"2497f6011738e8802bdc","11":"8b7a19d33a55d3e991f4","12":"a60e87835500f3d8d481","13":"c17225da170f07ad15da","14":"a59c5c4925827c0003f4","15":"8a0ff77c5c0028a4ef60","17":"58cca87b3d2814636971","19":"53f8a0d6f56fb58ede1d","20":"5675b9d50d3bd5472e20","21":"e9b5856e81e870cf57e4","22":"ce345ddcab5ddbf662ac","23":"ae2071768e10799bdc8e","24":"d5a6ffd54924c33bd545","25":"0c4542187a0391813ed3","26":"a9a9e2c8063bad4c8365","27":"fa032e931dade6e8a3a2","28":"f70d5a692d07998962a2","29":"e7f2ccc7206e7f6c0ded","30":"f0d3f4a009255f5f7366","31":"55db3610c50b2c5b7fa1","32":"e8d3ee10c34595f1f635","33":"ae13a1624e94201a7665","34":"e29ce9b581d54e04ae73","35":"cf462f9317fb66912d54","36":"bcf2f2a134f8ec953c29","37":"1d4343a0f615c7023b67","38":"79e11bd35e48b9fa7d9f","39":"ab1058d19c39db42ad1c","40":"1e26c21b8d5d072d7e54","41":"8c4693e55e62158248ad","42":"9215aff148e27d44fe43","43":"1af3509d7deaf0267a53","44":"909d641e5eb089effdf7","45":"d7d068a4089887734c2c","46":"0e9b1b07af6dc1a62287","47":"788248832945a1882904","48":"ec9fe27b3ca02edfd426","49":"e77fe153c5e2e81a7c38","50":"e85b3b8c121861d8409f","51":"d3965150c65d596127bc","52":"6390b276177d7a1ccd2b","53":"608cd6f492862e52a078","54":"940a6211cd0f7e1063ea","55":"cd9817d30d907f042216"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"eb6566f42565116308653f3d7ce716ddf3ab8d17","1":"2190e78c9daf4fab12dcee896403284741fd04dd","2":"styles","3":"09ba394c0665ec418beca5b9b20034fcbde74fdd","4":"8d1525f042279c504ed168ad26bd3afb2b2ab8c9","5":"a31980b1aa85f30412c1f61ee95f537dc2fe751c","6":"c12e60e7812e7433aa4d5228386c97d68b97f84c","7":"64b3804f7f48199f92d2b55a5eeac25417a4d075","8":"ec5c89a41aee28bbbfacb409a2e54bb31dec6f0f","9":"f0a8d1f93450005d571c1d9025195a10a7bb448e","10":"35df7e74774a94bfcd80eecbe4d85d2b3ae421d9","11":"3a153b92dded9af167fb9e42e48b843230cb12d3","12":"9f53efbd860637e77fc522713c17b5b048c0ab77","13":"a89bf5dab39d3bc6a5630fe2668c9dea90dc6cb6","14":"b58c2f089a40321ecd27b95a2d57fd8521f8b7a6","15":"e7ed3f1f536a60b0171a5d0b396cd70adcd45db2","17":"4a3ea9cd","19":"component---src-pages-404-js","20":"component---src-pages-404-old-js","21":"component---src-pages-custom-order-paid-js","22":"component---src-pages-custom-orders-js","23":"component---src-pages-order-paid-js","24":"component---src-pages-order-pay-failed-js","25":"component---src-pages-test-js","26":"component---src-pages-videos-js","27":"component---src-templates-about-us-js","28":"component---src-templates-admin-js","29":"component---src-templates-audios-js","30":"component---src-templates-author-js","31":"component---src-templates-authors-js","32":"component---src-templates-book-js","33":"component---src-templates-books-fairs-js","34":"component---src-templates-books-js","35":"component---src-templates-cart-items-new-js","36":"component---src-templates-cart-items-old-js","37":"component---src-templates-categories-js","38":"component---src-templates-category-js","39":"component---src-templates-checkout-js","40":"component---src-templates-checkout-new-js","41":"component---src-templates-contact-us-js","42":"component---src-templates-cookies-policy-js","43":"component---src-templates-feedback-js","44":"component---src-templates-gallery-page-js","45":"component---src-templates-get-brochure-js","46":"component---src-templates-index-js","47":"component---src-templates-login-redirect-js","48":"component---src-templates-mobile-about-us-js","49":"component---src-templates-my-profile-js","50":"component---src-templates-order-book-js","51":"component---src-templates-policy-js","52":"component---src-templates-publisher-js","53":"component---src-templates-publishers-js","54":"component---src-templates-signup-js","55":"component---src-templates-your-thoughts-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"1114e53fd1c33c7dae8a","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
